export default [
  {
    link: '/qui-sommes-nous',
    title: 'Qui sommes-nous ?',
    name: 'Qui sommes-nous ?'
  },
  {
    link: '/extraction-de-donnees',
    title: 'Export de données',
    name: 'Export de données'
  },
  {
    link: '/liens-utiles',
    title: 'Liens utiles',
    name: 'Liens utiles'
  },
  {
    link: '/faq',
    title: 'Foire aux questions',
    name: 'FAQ'
  },
  {
    link: '/contact',
    title: 'Nous contacter',
    name: 'Nous contacter'
  },
  {
    link: '/mentions-legales-cgu',
    title: 'Mentions légales / CGU',
    name: 'Mentions légales / CGU'
  },
  {
    link: '/infos-cnil',
    title: 'Infos CNIL',
    name: 'Infos CNIL'
  }
]

export const knowEverythingAboutCropsUrl = '/tout-savoir-sur-la-protection-des-cultures'
